import { render, staticRenderFns } from "./RptComprasGastos.vue?vue&type=template&id=16581258&"
import script from "./RptComprasGastos.vue?vue&type=script&lang=js&"
export * from "./RptComprasGastos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports